import clsx, { ClassValue } from "clsx";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { fromPairs } from "lodash";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const convertSearchParamsToObject = (searchParams: URLSearchParams) =>
  fromPairs(Array.from(searchParams.entries()));

export const formatNumber = (value: number) => {
  if (typeof value !== "number") {
    value = parseInt(value);
  }

  return new Intl.NumberFormat().format(parseInt(value.toFixed(0)));
};

dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(timezone);

export const dateFromNow = (date: string) => {
  return dayjs(date).tz(dayjs.tz.guess()).fromNow();
};
